import script from "./AdminFormElementRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementRadio.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementRadio.vue?vue&type=style&index=0&id=d3756494&lang=scss&scope=true"

const __exports__ = script;

export default __exports__